// extracted by mini-css-extract-plugin
export default {"container":"Container_container__1Ti4x","blockGroup":"Container_blockGroup__NwFen","currentBlockGroup":"Container_currentBlockGroup__WZ38o"};